import {FC, useLayoutEffect, useState} from "react";
import {Button, Modal, TextInput} from "@mantine/core";


type EditFileModalProps = {
    open: boolean
    onClose: () => void
    fileId: string
    onSubmitNewName: (directoryName: string, fileId: string) => void
    onSubmitNewPath: (newPath: string, fileId: string) => void
    path: string
    fileName: string
}
const EditFileModal:FC<EditFileModalProps> = (props) =>  {
    const [path, setPath] = useState(props.path);
    const [name, setName] = useState(props.fileName);
    const [open, setOpen] = useState(false)

    useLayoutEffect(() => {
        if (props.open && !open) {
            setOpen(true)
            setPath(props.path)
            setName(props.fileName)
        } else if (!props.open && open) {
            setOpen(false)
        }
    }, [props, open]);

    return (
        <Modal opened={props.open} onClose={props.onClose} title="New Room">
            <TextInput label='Path: (must start and end with "/")' placeholder="/..." value={path} onChange={(event) => setPath(event.currentTarget.value)}/>
            <Button disabled={!path || path.charAt(0) !== "/"} onClick={() => props.onSubmitNewPath(path, props.fileId)}>Move file to new path</Button>
            <TextInput label="Name:" placeholder="File Name" value={name} onChange={(event) => setName(event.currentTarget.value)}/>
            <Button disabled={!name} onClick={() => props.onSubmitNewName(name, props.fileId)}>Rename</Button>
        </Modal>
    );
}

export default EditFileModal